module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:swipe.up",
      value: (_vm.toLanding),
      expression: "toLanding",
      arg: "swipe",
      modifiers: {
        "up": true
      }
    }],
    staticClass: "page page-index",
    attrs: {
      "id": "Index"
    },
    on: {
      "DOMMouseScroll": _vm.forceShow,
      "mousewheel": _vm.forceShow
    }
  }, [_c('div', {
    staticClass: "video-wrapper"
  }, [(!_vm.Helpers.isMobile()) ? _c('cover-container', [_c('video', {
    ref: "video",
    staticClass: "video",
    attrs: {
      "id": "video",
      "autoplay": "",
      "loop": "",
      "muted": "",
      "preload": "",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/video/fifa.webm",
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "/static/video/fifa.mp4",
      "type": "video/mp4"
    }
  })])]) : _c('div', {
    staticClass: "video-poster"
  }), _vm._v(" "), _c('div', {
    ref: "videoPrev",
    staticClass: "video-preview",
    staticStyle: {
      "background-image": "url('/static/img/index/video-preview.gif')"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "overlay",
    staticClass: "page-overlay oh"
  }), _vm._v(" "), _c('div', {
    staticClass: "lines-wrapper"
  }, [_c('div', {
    ref: "lines1",
    staticClass: "lines1"
  }), _vm._v(" "), _c('div', {
    ref: "lines2",
    staticClass: "lines2"
  }), _vm._v(" "), (!_vm.$store.getters['GET_LOAD_ANIMATE']) ? _c('div', {
    ref: "circleWrapper",
    staticClass: "lines-circle-wrapper oh"
  }, [_c('div', {
    ref: "circle",
    staticClass: "lines-circle"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "logo",
    staticClass: "logo"
  }), _vm._v(" "), (!_vm.$store.getters['GET_LOAD_ANIMATE']) ? _c('div', {
    ref: "criroWrapper",
    staticClass: "criro-wrapper oh"
  }, [_c('div', {
    ref: "criro",
    staticClass: "criro"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "title-wrapper oh"
  }, [_c('h1', {
    ref: "title",
    staticClass: "title"
  }, [_vm._v("встреча года")])]), _vm._v(" "), _c('div', {
    staticClass: "text-wrapper oh"
  }, [_c('p', {
    ref: "text",
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\tЛюбишь компьютерные игры серии FIFA? Мастерски создаешь непобедимые команды? Способен выиграть даже с дублем? Тогда докажи свои умения и окажись в числе тех счастливчиков, которых мы позовем в редакцию на матч в FIFA 18 против реального футболиста РФПЛ.\n\t\t\t")])]), _vm._v(" "), _c('div', {
    ref: "arrow",
    staticClass: "scroll-bottom",
    on: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'Стрелка на главной')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/rules"
    }
  }, [_c('arrow-down')], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSkip),
      expression: "showSkip"
    }],
    staticClass: "skip",
    on: {
      "click": _vm.forceShow
    }
  }, [_vm._v("\n\t\t\tПропустить\n\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e853781","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Index.vue
// module id = 498
// module chunks = 1